import { ACADEMIC_STATUS_MAP } from 'constants/academic-status-map';
import { IAcademicRecord } from 'interfaces/academic_records';
import {
  IDisciplineModule,
  IGraduateDisciplineModule
} from 'interfaces/graduate_discipline_module';
import { IGraduateModule } from 'interfaces/graduate_courses';
import { getAPI } from 'requests/api';

const CURRICULUM_GRID_MISSING_RECORD_STATUS = {
  label: 'Não concluído',
  color: 'default'
};

export const getCurriculumGridStatusDisplay = (
  status?: IAcademicRecord['status']
) => {
  if (!status) {
    return CURRICULUM_GRID_MISSING_RECORD_STATUS;
  }

  return ACADEMIC_STATUS_MAP[status] ?? CURRICULUM_GRID_MISSING_RECORD_STATUS;
};

type DisciplineWithAcademicRecord = IDisciplineModule & {
  academicRecordStatus?: IAcademicRecord['status'];
};

export interface CurriculumGridData extends IGraduateModule {
  disciplines: DisciplineWithAcademicRecord[];
}

export const fetchCurriculumGridData = async (
  courseId: string,
  enrollmentId: string
): Promise<CurriculumGridData[]> => {
  const [disciplinesModules, academicRecords] = await Promise.all([
    getAPI().get(
      `/admin/graduate/disciplines_modules?items=100&page=1&filter[by_course]=${courseId}`
    ),
    getAPI().get(
      `/admin/graduate/academic_records?items=100&page=1&filter[by_course_enrollment_id]=${enrollmentId}&_order=desc&_sort=updated_at`
    )
  ]);

  return mountCurriculumGridData(
    disciplinesModules.data,
    academicRecords.data,
    courseId
  );
};

export const mountCurriculumGridData = (
  disciplinesModules: IGraduateDisciplineModule[],
  academicRecords: IAcademicRecord[],
  courseId: string
) => {
  if (disciplinesModules.length === 0) {
    return [];
  }

  const modules: CurriculumGridData[] = [];

  for (const dm of disciplinesModules) {
    if (dm.module.course_id !== courseId) {
      continue;
    }

    if (!modules.some(m => m.id === dm.module.id)) {
      modules.push({
        ...dm.module,
        disciplines: []
      });
    }
  }

  for (const dm of disciplinesModules) {
    const module = modules.find(m => m.id === dm.module.id);

    if (!module) {
      continue;
    }

    module.disciplines.push({
      ...dm.discipline,
      disciplineModuleKind: dm.kind,
      disciplineModuleClassification: dm.classification,
      academicRecordStatus: academicRecords.find(
        ar => ar.discipline.id === dm.discipline.id
      )?.status
    });
  }

  return modules;
};
